<template>
  <div style="display: inline-block;">

    <button
      v-if="!loadingStatus"
      :disabled="!(followedProductExists && productKuvailuTulossa)"
      @click="saveKarhu"
      type="button"
      class="btn btn-default">
      Pyydä kuvailun kiirehtimistä

      <span style="margin-left: 10px" data-toggle="tooltip" data-placement="bottom"
          title="Kiirehtimispyynnön voi tehdä vain sellaisista tuotteista, jotka on laitettu omalle listalle ja joiden kuvailustatus on 'kuvailu tulossa'.">
          <i class="fa fa-question-circle fa-lg" aria-hidden="true"></i>
      </span>
    </button>

    <button v-if="loadingStatus == 'loading'" disabled type="button" class="btn btn-default" style="width: 165px; height: 34px">
      <i class="fa fa-spinner fa-spin fa-lg fa-fw"></i>
      <span class="sr-only">Loading...</span>
    </button>

    <button v-if="loadingStatus == 'success'" disabled type="button" class="btn btn-default" style="width: 165px; height: 34px">
      <i class="fa fa-check fa-lg text-success"></i>
      <span class="sr-only">Ok</span>
    </button>

    <button v-if="loadingStatus == 'error'" disabled type="button" class="btn btn-default" style="width: 165px; height: 34px">
      <i class="fa fa-close fa-lg text-danger"></i>
      <span class="sr-only">Error</span>
    </button>

  </div>
 </template>

<script>

import { userMixin } from '@/mixins/userMixin.js'
import { EventBus } from '@/event_bus.js';

export default {
  emits: ['reload-queries'],
  
  mixins: [
    userMixin,
  ],  

  props: {
    productId: String,
    parentId: String,
    currentUser: Object,
    productKuvailuTulossa: Boolean,
  },

  data() {
    return {
      followedProductId: null,
      loadingStatus: null,
    }
  },

  computed: {
    followedProductExists() {
      return this.followedProductId ? true : false
    },
  },

  created() {
    // FollowedProductButton is clicked so we need to get followed product status again.
    EventBus.$on('refresh-followed-product', this.getFollowedProduct);
  },

  mounted() {
    this.getFollowedProduct()
  },

  beforeDestroy() {
    EventBus.$off('refresh-followed-product', this.getFollowedProduct);
  },

  methods: {

    getFollowedProduct() {
      if (!this.productId) {
        return
      } 

      const config = {
        url: `/luettelointi/omalista/search?product_id=${this.productId}`,
        method: 'get',
      }

      axios(config)
      .then((response) => {
        if (response.data && response.data.product) {
          this.followedProductId = response.data.product.id
        } else {
          this.followedProductId = null
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },

    saveKarhu() {
      const formData = new FormData()

      formData.append("parent_id", this.parentId)  
      formData.append("product_id", this.productId)  

      formData.append("fast-query", 'fast-query')
      formData.append("message", `${this.userName(this.currentUser)} pyytää kuvailua`)

      const config = {
        url: `/luettelointi/kysely`,
        method: 'post',
        data: formData,
      }

      this.sendQuery(config)
    },

    sendQuery(config) {
      this.loadingStatus = "loading"
      
      axios(config)
      .then((response) => {
        //console.log(response)

        if (response.data.error) {
          console.log(response.data.error)
          this.loadingStatus = "error"
        } else {
          this.loadingStatus = "success"

          this.reloadQueries()
        }

        setTimeout(() => {
          this.loadingStatus = null
        }, 1000)
      })
      .catch((error) => {
        console.log(error)

        this.loadingStatus = "error"

        setTimeout(() => {
          this.loadingStatus = null
        }, 1000)
      })
      .finally(() => {
        //
      });

    },

    reloadQueries() {
      this.$emit('reload-queries')
    },

  },

}
</script>

<style scoped>

</style>
